import { sendGet, sendPost, type Response } from '../hooks/use-fetch'
import { type SaveSurveyResultRequest } from '../models/requestObjects/SurveyRequestObjects'
import { type SurveySchema } from '../models/SurveySchema'

export async function GetSurvey (schemaId: number, planOrgId: number): Promise<Response<SurveySchema>> {
  return await sendGet(`Survey/${schemaId}?planOrgId=${planOrgId}`)
}

export async function SaveSurveyResults (surveyResult: SaveSurveyResultRequest): Promise<void> {
  await sendPost('Survey/SaveResults', surveyResult)
}
